import { gql, TypedDocumentNode } from '@common/hooks';
import {
  CreateTierMutationCgResponse,
  CreateTierMutationVariables,
} from '@common/graphql/schema';

export const CreateTierMutation: TypedDocumentNode<
  CreateTierMutationCgResponse,
  CreateTierMutationVariables
> = gql`
  mutation CreateTier($input: CreateTierInput!) {
    createTier(input: $input) {
      tier {
        id
        name
      }
      errors {
        ... on NotFoundError {
          message
        }
        ... on BadUserInputError {
          message
        }
        ... on ModelValidationError {
          message
        }
        ... on RecordNotUniqueError {
          message
        }
      }
    }
  }
`;
